import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ClickImage from './ClickImage';
import ImgResponsive from './ImgResponsive';

const CarouselHome: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto', padding: '0px 0px 0px 0px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-1.jpeg'} alt={'Green Rides Pune - Welcome'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-2.jpeg'} alt={'Pune to Mumbai Airport Drop Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-3.jpeg'} alt={'Mumbai Airport to Pune Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-4.jpeg'} alt={'Pune to Mumbai Drop Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-5.jpeg'} alt={'Pune to Mumbai Drop Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-6.jpeg'} alt={'Mumbai to Pune Drop Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-7.jpeg'} alt={'Pune to Mumbai Cab'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-8.jpeg'} alt={'BYD e6 Luggage Space'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImagesNew/GrpImages-9.jpeg'} alt={'Promo code'}></ImgResponsive>
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselHome;
